module.exports = __webpack_public_path__ + "img/mira_330m_detail_rsh.b9abf0f7.jpg";